var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$IsLogged)?_c('Sidebar'):_vm._e(),_c('v-main',{staticClass:"content-container"},[_c('div',{staticClass:"main-content"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }